import { cn } from 'src/lib/utils';

type Props = {
  heading: string;
  text: React.ReactNode | string;
  className?: string;
};

const TextBlock = ({ heading, text, className }: Props) => (
  <div className={cn('py-2 space-y-1', className)}>
    <h3 className="text-foreground text-[11px]">{heading}</h3>
    <p className="text-[11px] leading-[1.6] text-foreground">{text}</p>
  </div>
);

export default TextBlock;
